import type { RouteObject } from 'react-router-dom';
import { PermissionRoute } from '@/features/auth';
import { VehicleSearch } from '../components/VehicleSearch/VehicleSearch';

export const vehiclesRoutes: RouteObject[] = [
    {
        path: 'vehicles',
        children: [
            {
                element: (
                    <PermissionRoute
                        requiredPermissions={[{ resource: 'vehicle', action: 'browse' }]}
                    />
                ),
                children: [
                    {
                        path: 'search',
                        element: <VehicleSearch showMotHistory />,
                    },
                ],
            },
        ],
    },
];
